<template>
  <div class="canvas-container" ref="canvasContainer">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
export default {
  name: "koiote-label",

  props: {
    input: {
      type: Object,
      required: true
    },
  },

  computed: {
    labelText() {
      const text = this.input?.customized?.label;
      return text && text.length > 0 ? text : "SIN ETIQUETA";
    },
    // Colores con valores por defecto por si fallan
    colors() {
      return {
        fg: this.input?.customized?.foreground_color || '#000000',
        bg: this.input?.customized?.background_color || 'transparent',
        border: this.input?.customized?.border_color || 'transparent'
      };
    }
  },

  watch: {
    input: {
      handler() {
        this.$nextTick(() => this.draw());
      },
      deep: true
    }
  },

  mounted() {
    this.updateCanvasSize();
    this.resizeObserver = new ResizeObserver(() => this.updateCanvasSize());
    this.resizeObserver.observe(this.$refs.canvasContainer);
  },

  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },

  methods: {
    updateCanvasSize() {
      const container = this.$refs.canvasContainer;
      const canvas = this.$refs.canvas;
      if (!container || !canvas) return;

      canvas.width = container.offsetWidth;
      canvas.height = container.offsetHeight;
      this.draw();
    },

    // Función para dibujar rectángulos redondeados
    roundRect(ctx, x, y, width, height, radius) {
      if (width < 2 * radius) radius = width / 2;
      if (height < 2 * radius) radius = height / 2;
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.arcTo(x + width, y, x + width, y + height, radius);
      ctx.arcTo(x + width, y + height, x, y + height, radius);
      ctx.arcTo(x, y + height, x, y, radius);
      ctx.arcTo(x, y, x + width, y, radius);
      ctx.closePath();
    },

    draw() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      const w = canvas.width;
      const h = canvas.height;

      ctx.clearRect(0, 0, w, h);

      // 1. Dibujar el Fondo
      if (this.colors.bg !== 'transparent') {
        ctx.fillStyle = this.colors.bg;
        this.roundRect(ctx, 2, 2, w - 4, h - 4, 5); // 5px de redondeo
        ctx.fill();
      }

      // 2. Dibujar el Borde
      if (this.colors.border !== 'transparent') {
        ctx.strokeStyle = this.colors.border;
        ctx.lineWidth = 2;
        this.roundRect(ctx, 2, 2, w - 4, h - 4, 5);
        ctx.stroke();
      }

      // 3. Configurar Texto
      // Calculamos un tamaño de fuente que deje aire (padding)
      const padding = 10;
      let fontSize = h * 0.6; 
      ctx.font = `bold ${fontSize}px "Segoe UI", Roboto, Helvetica, Arial, sans-serif`;
      
      // Ajuste de ancho (si el texto es muy largo, achicar la fuente)
      const metrics = ctx.measureText(this.labelText);
      if (metrics.width > w - padding) {
        fontSize = fontSize * ((w - padding) / metrics.width);
        ctx.font = `bold ${fontSize}px "Segoe UI", Roboto, Helvetica, Arial, sans-serif`;
      }

      // 4. Estética de texto (Sombra suave para legibilidad)
      ctx.shadowColor = "rgba(0, 0, 0, 0.2)";
      ctx.shadowBlur = 4;
      ctx.shadowOffsetX = 1;
      ctx.shadowOffsetY = 1;

      // 5. Dibujar el texto centrado
      ctx.fillStyle = this.colors.fg;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(this.labelText, w / 2, h / 2);
    },
  },
};
</script>

<style scoped>
.canvas-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* Efecto opcional: un suave gradiente para simular cristal */
  background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.05) 100%);
  border-radius: 4px;
}
canvas {
  display: block;
}
</style>